import { Component } from "react"

class UserName extends Component{
    constructor(props){
        super(props)
        this.name = "ユーザ名"
    }
    validate(callbackDialog,required){
        if(required && String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if(this.props.length > 30){
            callbackDialog("エラー",this.name + "は30文字以内にしてください。")
            return false
        }
        return true
    }
}

export default UserName;